import { combineReducers } from 'redux';
import { REDUX } from 'constants/index';
import { getReducer } from '../lib/reducerCreator';
import { ReferralMeta } from '../../../types/referrals.type';

const reducers = getReducer(REDUX.FETCH_REFERRAL_METADATA, {} as ReferralMeta);

export default combineReducers({ ...reducers });
